import { useEffect, useState } from 'react';
import pickupIcon from './pickup.png';
import dropoffIcon from './dropoff.png';
import truckIcon from './truck.png';
import truckIconSelected from './truck-selected.png';
import truckIconAvailable from './truck-available.png';

const MarkersURL = {
  PICKUP: pickupIcon,
  DROPOFF: dropoffIcon,
};

const getStopMarkerIcon = ({ stop_type }) => {
  const url = MarkersURL[stop_type];
  return {
    url,
    size: new window.google.maps.Size(32, 32),
    scaledSize: new window.google.maps.Size(32, 32),
  };
};

const getDriverMarkerIcon = (isSelected, available) => {
  if (isSelected) {
    return truckIconSelected;
  }
  if (available) {
    return truckIconAvailable;
  }

  return truckIcon;
};

const useStopMarkers = (item, skins) => {
  const { id, stops = [], shipper_orders_skin = {} } = item;
  const [stopMarkers, setStopMarkers] = useState([]);

  const googleEnabled = !!window.google;

  useEffect(() => {
    if (!googleEnabled) {
      return;
    }

    setStopMarkers(
      stops.map(({ shipper_order_id, stop_type, address, ...stop }) => ({
        latitude: address.latitude,
        longitude: address.longitude,
        stop_type,
        icon: getStopMarkerIcon({ skins, skin: shipper_orders_skin[shipper_order_id], stop_type }),
        address,
        ...stop,
      }))
    );
    //eslint-disable-next-line
  }, [id, googleEnabled]);

  return stopMarkers;
};

const getIconSize = (isSelected) => {
  return isSelected ? new window.google.maps.Size(32, 32) : new window.google.maps.Size(24, 24);
};

const useDriverMarkers = (driverPositions, selectedPosition) => {
  const [driverMarkers, setDriverMarkers] = useState([]);

  const googleEnabled = !!window.google;

  useEffect(() => {
    if (!googleEnabled) {
      return;
    }

    setDriverMarkers(
      driverPositions.map(({ latitude, longitude, driver_id, available, ...rest }) => ({
        latitude,
        longitude,
        driver_id,
        icon: {
          url: getDriverMarkerIcon(selectedPosition === driver_id, available),
          size: getIconSize(selectedPosition === driver_id),
          scaledSize: getIconSize(selectedPosition === driver_id),
        },
        ...rest,
      }))
    );
  }, [googleEnabled, driverPositions, selectedPosition]);

  return driverMarkers;
};

const useStopBounds = (positions) => {
  const [bounds, setBounds] = useState(null);

  useEffect(() => {
    if (!window.google || !window.google.maps) {
      return;
    }

    const googleBounds = new window.google.maps.LatLngBounds();

    positions.reduce((_, position) => {
      const p = new window.google.maps.LatLng(position.latitude, position.longitude);
      googleBounds.extend(p);

      return googleBounds;
    }, googleBounds);

    setBounds(googleBounds);
  }, [positions]);

  return bounds;
};

const getLatLng = (stop) => {
  const {
    address: { latitude, longitude },
  } = stop;
  return new window.google.maps.LatLng(latitude, longitude);
};

const getRoute = (stops) => {
  const origin = getLatLng(stops[0]);
  const destination = getLatLng(stops[stops.length - 1]);
  const waypoints = stops
    .map((stop, key) => {
      if (key === 0 || key === stops.length - 1) {
        return null;
      }

      return {
        location: getLatLng(stop),
        stopover: true,
      };
    })
    .filter((notnull) => notnull);

  return {
    avoidFerries: true,
    origin,
    destination,
    waypoints,
    optimizeWaypoints: true,
    travelMode: window.google.maps.TravelMode.DRIVING,
  };
};

export { useStopMarkers, useStopBounds, getRoute, useDriverMarkers };
